import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import './FooterFigma.css';
import { useSelector } from "react-redux";
import { useModal } from "../../hooks/ModalContext";
import TransparentLogo from '../../assets/img/tranLogo1024.png'

function FooterFigma() {
  const { t } = useTranslation();
  const [NewsLetterClick, setNewsLetterClick] = useState(false);
  const [show, setShow] = useState(false);
  const navigate = useNavigate()

  const { api_token } = useSelector((state) => state.auth);
  const { setActiveModal } = useModal();

  const handleSubscribeClick = () => {
    setNewsLetterClick(true); // Triggers modal open
    setShow(true);
  };

  return (
    <div className="pg-footer bg-light">
      <footer className="footer rounded-4">
        <div className="text-center m-0 pt-5 px-2">
          <h5 className="fw-bold text-white">
            {t("@All-prices-including-taxes-and-fees")}
          </h5>
          <hr />
        </div>
        <div className="container pt-0">
          <div className="row justify-content-start justify-content-sm-center">
            {/* Company Column */}
            <div className="col-6 col-md-4 col-lg-2">
              <div className="site-branding flex-shrink-0 bg-white d-flex justify-content-center">
                <a href="/" className="brand-logo">
                  <h3 className="m-0">Amzio</h3>
                  <img
                    src={TransparentLogo}
                    alt="Amzio Logo"
                  />
                </a>
              </div>
            </div>

            <div className="col-12 col-md-4 col-lg-7">
              <div className="d-flex flex-md-row flex-wrap justify-content-start justify-content-md-evenly">

                {/* Company */}
                <div className="footer-menu col-6 col-md-auto">
                  <h2 className="footer-menu-name">{t("Company")}</h2>
                  <ul className="footer-menu-list">
                    <li className="footer-links-color">
                      <Link to="/about-us">{t("About-Us")}</Link>
                    </li>
                    <li className="footer-links-color">
                      <Link to="/contact-us">{t("Contact-Us")}</Link>
                    </li>
                    <li className="footer-links-color">
                      <Link to="/faqs">{t("FAQS")}</Link>
                    </li>
                  </ul>
                </div>

                {/* Quick Links */}
                <div className="footer-menu col-6 col-md-auto">
                  <h2 className="footer-menu-name">{t("Quick-Links")}</h2>
                  <ul className="footer-menu-list">
                    <li className="footer-links-color">
                      <Link to="/ask-a-questions">{t("Support-Center")}</Link>
                    </li>
                    <li className="footer-links-color">
                      <div
                        role="button"
                        onClick={() => {
                          if (api_token) navigate("/order");
                          else setActiveModal("login");
                        }}
                      >
                        {t("Track-Orders")}
                      </div>
                    </li>
                    <li className="footer-links-color">
                      <Link to="/happy-customers">{t("Happy-Customers")}</Link>
                    </li>
                  </ul>
                </div>

                {/* Legal */}
                <div className="footer-menu col-6 col-md-auto">
                  <h2 className="footer-menu-name">Legal</h2>
                  <ul className="footer-menu-list">
                    <li className="footer-links-color">
                      <Link to="/terms&condition">{t("Terms&Conditions")}</Link>
                    </li>
                    <li className="footer-links-color">
                      <Link to="/refund-policies">{t("Refund-Policies")}</Link>
                    </li>
                    <li className="footer-links-color">
                      <Link to="/return-policies">{t("Return-Policies")}</Link>
                    </li>
                  </ul>
                </div>

              </div>
            </div>

            {/* Call to Action Column */}
            <div className="col-12 col-md-4 col-lg-2">
              <div className="footer-call-to-action p-3 d-flex flex-column align-items-center">
                <div>
                  <h2 className="footer-call-to-action-title">
                    {t("Lets-Chat")}
                  </h2>
                  <p className="footer-call-to-action-description">
                    {t("Have-a-support-question?")}
                  </p>
                  <Link
                    className="footer-call-to-action-button"
                    to="/ask-a-questions"
                  >
                    {t("Ask-a-Question")}
                  </Link>
                </div>
              </div>
              {/* <div className="footer-call-to-action mt-0 pt-0">
                <p className="footer-call-to-action-description">
                  {t("Would you like to Subscribe to our Newsletter?")}
                </p>
                <Link
                  className="footer-call-to-action-button"
                  to="#"
                  onClick={handleSubscribeClick}
                >
                  {t("Subscribe Now")}
                </Link>

                <SubscribeModal
                  show={show}
                  setShow={setShow}
                  NewsLetterClick={NewsLetterClick}
                  setNewsLetterClick={setNewsLetterClick}
                />
              </div> */}
            </div>
          </div>

          <div className="row pt-3">
            {/* <div className="col-12 d-flex justify-content-center gap-3">
              <Link
                className="footer-social-link linkedin text-white"
                to="#"
                target="_blank"
              >
                <FontAwesomeIcon icon={["fab", "linkedin-in"]} />
              </Link>
              <Link
                className="footer-social-link twitter text-white"
                to="#"
                target="_blank"
              >
                <FontAwesomeIcon icon={["fab", "twitter"]} size="2x" />
              </Link>
              <Link
                className="footer-social-link youtube text-white"
                to="#"
                target="_blank"
              >
                <FontAwesomeIcon icon={["fab", "youtube"]} />
              </Link>
              <Link
                className="footer-social-link github text-white"
                to="#"
                target="_blank"
              >
                <FontAwesomeIcon icon={["fab", "github"]} size="2x" />
              </Link>
            </div> */}
          </div>

        </div>
        <hr />
        <div className="footer-copyright pt-0 px-0 px-sm-2">
          <div className="footer-copyright-wrapper">
            <p className="footer-copyright-text fw-bold fs-6 text-white">
              {t("Copyright")}
              <Link
                className="footer-copyright-link ps-1"
                to="http://amzio.com"
                target="_blank"
                style={{ textDecoration: "underline" }}
              >
                Amzio.com
              </Link>
            </p>
          </div>
        </div>
      </footer >
    </div >
  );
}

export default FooterFigma;
